module.exports = __webpack_public_path__ + "static/img/tydx.4d1dc70.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bc/tydx.png
// module id = PqZ3
// module chunks = 0